module.exports = __webpack_public_path__ + "img/b9.0b62c751.jpg";